import {
  INIT_REDUCER,
  CLEAR_ERRORS,
  CREATE_ERRORS,
  GET_VALIDATED_PC_SCANNED_DOCUMENTS_REQUEST,
  DELETE_VALIDATED_PC_SCANNED_DOCUMENT_REQUEST,
} from './types';

const deleteValidatedScannedDocument = (payload) => ({
  type: DELETE_VALIDATED_PC_SCANNED_DOCUMENT_REQUEST,
  payload,
});

const getValidatedScannedDocuments = (payload) => ({
  type: GET_VALIDATED_PC_SCANNED_DOCUMENTS_REQUEST,
  payload,
});

const initReducer = () => ({
  type: INIT_REDUCER,
});

const clearErrors = () => ({
  type: CLEAR_ERRORS,
});

const createErrors = (payload) => ({
  type: CREATE_ERRORS,
  payload: payload,
});

export {
  getValidatedScannedDocuments,
  initReducer,
  clearErrors,
  createErrors,
  deleteValidatedScannedDocument,
};
